import { FC } from 'react';

import polyllmChatConfig from '~/projects/polyllm-chat/config';
import { ProjectConfigType } from '~/projects/types';

export enum PROJECT {
  'POLYLLM_CHAT' = 'chatwithai',
}

type ConfigType = {
  project: PROJECT;
  getProjectName(): string;
  getBigLogo(): FC<{ className?: string }>;
  getSupportEmail(): string;
};

class Config implements ConfigType {
  private config: ProjectConfigType = polyllmChatConfig;
  public project: PROJECT = PROJECT.POLYLLM_CHAT;

  getProjectName(): string {
    return this.config.name;
  }

  getLogo(): FC<{ className?: string }> {
    return this.config.getLogo();
  }

  getBigLogo(): FC<{ className?: string }> {
    return this.config.getBigLogo();
  }

  getSendIcon(): FC<{ className?: string }> {
    return this.config.getSendIcon();
  }

  getSupportEmail(): string {
    return this.config.supportEmail;
  }

  getIsExtensionAvailable(): boolean {
    return this.config.isExtensionAvailable;
  }

  checkIsToolAvailable(id: string): boolean {
    const availableToolIds = this.config?.availableToolIds || [];

    if (availableToolIds.length) {
      return availableToolIds.includes(id);
    }
    return true;
  }
}

const projectConfig = new Config();

export default projectConfig;
